module.exports = __webpack_public_path__ + "img/img_detail1.f709c2ae.jpg";